import React from 'react';

import { useStreamTimeOffset } from '@vlabs/monokit/entities/streams';
import InfoRow from '@vlabs/shared/components/info-row/InfoRow';
import { Panel } from '@vlabs/uikit';
import { CircleBar } from '@vlabs/uikit/components/circle-bar/CircleBar';
import { useTranslation } from 'react-i18next';

import st from './ScoreBlock.module.sass';

export const ScoreBlock = ({ event, scoreValue, extraRows }) => {
  const { t } = useTranslation();
  const { timeInterval } = useStreamTimeOffset(event?.event?.stream_id, event?.event?.overview?.time_offset);

  return (
    <Panel className={st.Panel} data-testid='ScoreBlock'>
      {scoreValue && (
        <div className={st.CircleBarWrapper}>
          <div className={st.CircleBarTitle} data-testid='CircleBarTitle'>
            {t(`videoAnalytics:details.${event?.event_type}.circle bar.label`)}
          </div>
          <div className={st.CircleBar} data-testid='CircleBar'>
            <CircleBar value={scoreValue} />
          </div>
        </div>
      )}

      {!scoreValue && (
        <div className={st.CircleBarWrapper}>
          <div className={st.CircleBarTitle} data-testid='CircleBarTitleNoScore'>
            {t(`videoAnalytics:details.${event?.event_type}.circle bar.label`)}
          </div>
          <span className={st.CircleBarSubtitle}>{t('videoAnalytics:details.not computable')}</span>
        </div>
      )}

      <div className={st.Divider} />

      <InfoRow
        className={st.VideoAnalyticDetails__InfoRow}
        title={t('videoAnalytics:frame time')}
        value={timeInterval}
      />
      {extraRows}
    </Panel>
  );
};
